import { createContext, useContext, useEffect } from "react";

export const PageMetaContext = createContext(() => {});

// Show a subtitle, optional title override and data timestamp in the top header while the page is mounted.
export function usePageMeta(subtitle, title, updatedAt) {
    const set = useContext(PageMetaContext);
    useEffect(() => { set({ subtitle, title, updatedAt }); }, [set, subtitle, title, updatedAt]);
    useEffect(() => () => set({}), [set]);
}
